import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Home from "@/pages/Home";
import Admin from "@/pages/Admin";
import Impressum from "@/pages/Impressum";
import Datenschutz from "@/pages/Datenschutz";
import Links from "@/pages/Links";
import CookieTab from "@/components/site/CookieTab";
import { trackEvent } from "@/lib/track";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    trackEvent("pageview", "pageview");
  }, [pathname]);
  return null;
}

function ClickTracker() {
  useEffect(() => {
    const onClick = (e) => {
      const el = e.target.closest("[data-testid]");
      if (el) trackEvent(el.dataset.testid);
    };
    document.addEventListener("click", onClick);
    return () => document.removeEventListener("click", onClick);
  }, []);
  return null;
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <ClickTracker />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/impressum" element={<Impressum />} />
        <Route path="/datenschutz" element={<Datenschutz />} />
        <Route path="/links" element={<Links />} />
      </Routes>
      <CookieTab />
    </BrowserRouter>
  );
}

export default App;
